// balloonPumpGameSlice.js
import { createSlice } from '@reduxjs/toolkit'
import { getMyBets, getTopBets } from './balloonPumpGame.thunk'

const initialState = {
  selectedAmount: 0.1,
  currentScore: 0.1,
  myBetsData: [],
  topBetsData: [],
  topBetsLoading: false,
  myBetsLoading: false,
  isHolding: false,
  betLock: false
}

const balloonPumpGameSlice = createSlice({
  name: 'balloonPumpGame',
  initialState,
  reducers: {
    setSelectedAmount: (state, action) => {
      state.selectedAmount = action.payload
    },
    setCurrentScore: (state, action) => {
      state.currentScore = action.payload
    },
    setIsHolding: (state, action) => {
      state.isHolding = action.payload
    },
    setBetLock: (state, action) => {
      state.betLock = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMyBets.pending, (state, action) => {
        return {
          ...state,
          myBetsLoading: true

        }
      })
      .addCase(getMyBets.rejected, (state, action) => {
        return {
          ...state,
          myBetsData: initialState.myBetsData,
          myBetsLoading: false

        }
      })
      .addCase(getMyBets.fulfilled, (state, action) => {
        return {
          ...state,
          myBetsData: action.payload,
          myBetsLoading: false
        }
      })
      .addCase(getTopBets.pending, (state, action) => {
        return {
          ...state,
          topBetsLoading: true
        }
      })
      .addCase(getTopBets.fulfilled, (state, action) => {
        return {
          ...state,
          topBetsData: action.payload,
          topBetsLoading: false
        }
      })
      .addCase(getTopBets.rejected, (state, action) => {
        return {
          ...state,
          topBetsData: [],
          topBetsLoading: false
        }
      })
  }
})

export const { setSelectedAmount, setCurrentScore, setIsHolding, setBetLock } = balloonPumpGameSlice.actions
export default balloonPumpGameSlice.reducer
